import styled from 'styled-components';
import { tokens } from '@splashthat/doppler';
import { FONT_PROPERTIES } from 'common/components/TouchpointEditor/components/TouchpointContainer';
import { Content } from '@radix-ui/react-tabs';

export const StyledAddToCalendarButton = styled.button`
    border: none;
    background-color: transparent;
    width: fit-content;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: ${tokens.size.sizeRelative100};
    ${FONT_PROPERTIES}

    &:hover {
        color: ${(props) => props.$fontColorHover};
    }
`;

export const StyledCalendarDownloadTabs = styled(Content)`
    grid-area: add-to-calendar;
`;
